import Model, { attr, belongsTo } from '@ember-data/model';

export default class ApprovalCheck extends Model {
  @belongsTo('entry', { async: true, inverse: 'approvalChecks' }) entry;

  @attr('string') status;
  @attr('array') report;
}
